import { observable, action, makeObservable } from 'mobx';
import { paramsDefaults } from '../constants/uiParams';

export const makeValue = (type, id) => `${type}_${id}`;

class Suggestion {
  text = paramsDefaults.GeoName;
  type = paramsDefaults.GeoTypeId;
  id = paramsDefaults.GeoId;
  value = makeValue(this.type, this.id);

  constructor(suggestion) {
    makeObservable(this, {
      text: observable,
      type: observable,
      id: observable,
      value: observable,
      setSuggestion: action,
    });

    if (suggestion) {
      this.setSuggestion(suggestion);
    }
  }

  setSuggestion = (suggestion) => {
    const {
      text,
      type,
      id,
      value,
    } = suggestion;
    this.id = id;
    this.text = text;
    this.type = type;
    this.value = value;

    if (!this.value) {
      this.value = makeValue(type, id);
    }
  }
}

export default Suggestion;
